module.exports = __webpack_public_path__ + "static/media/modal-2-body.3fdc93f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/MatchingRules/modal-2-body.svg
// module id = ./src/MatchingRules/modal-2-body.svg
// module chunks = 0